import React from 'react'
import { Helmet } from 'react-helmet'
// import { useStaticQuery, graphql } from 'gatsby'

export default ({ title }) => {

  // const { site } = useStaticQuery(graphql`
  //   query {
  //     site {
  //       siteMetadata {
  //         title
  //         description
  //         author
  //       }
  //     }
  //   }
  // `)

  const metaTitle = title || 'Léo De Spiegeleer - Front-End Dev & Creative Coder'
  const metaDescription = `Ceci est le site professionnel de Léo. Il y présente ses travaux ainsi que son expérience au monde et son internet.`
  const metaImage = 'https://res.cloudinary.com/dzxowa2ja/image/upload/v1603297957/socialthumb_svdbr2.png'
  const linkFavicon = 'https://res.cloudinary.com/dzxowa2ja/image/upload/v1603299769/favicon_xbo2wh.png'
  const metaURL = '/'

  return (
    <Helmet>
      <html lang="fr" dir="ltr" />

      {/* Primary Meta Tags */}
      <meta charset="utf-8" />
      <meta httpEquiv="x-ua-compatible" content="ie=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
      <title>{metaTitle}</title>
      <meta name="title" content={metaTitle} />
      <meta name="description" content={metaDescription} />

      {/* Primary Link Tags */}
      <link rel="icon" type="image/png" href={linkFavicon} />
      <link rel="canonical" href={metaURL} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={metaURL} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={metaURL} />
      <meta property="twitter:title" content={metaTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={metaImage} />
    </Helmet>
  )
}
